module.exports = "/assets/site/images/si.jpg?454a15a29f5d12cee7df4be8874eda86";